import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  loadShipments (owner, search) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/shipments/?ordering=-created_at&search=${search || ''}&owner=${owner || ''}`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  createShipment (shipment) {
    return new Promise((resolve, reject) => {
      axiosInstance.post('/shipments/', shipment).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  updateShipment (shipment) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch(`/shipments/${shipment.id}/`, shipment).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  checkSlug (slug) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/system/check-slug/shipment/${slug}/`).then((res) => {
        if (res.data.status === 'exists') {
          resolve('exists')
        } else {
          resolve('available')
        }
      }).catch((err) => {
        reject(err)
      })
    })
  }

}
